'use client';

import {
  Examples,
  ExamplesActions,
  ExamplesHeader,
  ExamplesHeading,
  ExamplesRow,
} from '@/components/examples';
import { processConfig } from '@/features/process/process.config';
import { useLocalePath } from '@/shared/hooks';
import { Button } from '@embira/ui/components/button';
import { useT } from 'next-i18next/client';
import Image from 'next/image';
import Link from 'next/link';
import React, { type FC } from 'react';

export const ExamplesBlock: FC = () => {
  const { t } = useT(processConfig.i18nNamespaces);
  const { to } = useLocalePath();

  return (
    <ExamplesHeader>
      <Examples>
        <ExamplesRow>
          <ExamplesHeading>{t('process:examples.title')}</ExamplesHeading>
          <ExamplesActions>
            <Button asChild size="lg">
              <Link href={to('/projects')}>{t('process:btn.exploreOurWork')}</Link>
            </Button>
          </ExamplesActions>
        </ExamplesRow>
        <Image
          src="/images/examples.png"
          className={`mx-auto`}
          alt="examples"
          loading={'eager'}
          width={782}
          height={464}
        />
      </Examples>
    </ExamplesHeader>
  );
};
